'use es6';

import toolsHubSpotterClient from './clients/toolsHubSpotterClient';
export default (({
  ignoreRedirect = false
} = {}) => toolsHubSpotterClient.get('/internal-login/v1/sessions', {
  ignoreRedirect
}));